import * as React from 'react';
import { useParams } from 'react-router';

import { MembersContextProvider } from '../members-context';
import { OnboardingContextProvider } from '../onboarding.context';
import { PredictionsInfoContext } from '../../forecast/detail/context/predictions-info-context';
import { ReportBuilderPage } from '../pages/edit-report-page';
import { ReportsContextProvider } from '../reports.context';
import { TemplatesContextProvider } from '../templates.context';

export const ReportContainer = () => {
  const { reportId } = useParams();
  const id = reportId || '';

  return (
    <PredictionsInfoContext>
      <MembersContextProvider>
        <ReportsContextProvider>
          <TemplatesContextProvider>
            <OnboardingContextProvider>
              <ReportBuilderPage key={id} reportId={id} />
            </OnboardingContextProvider>
          </TemplatesContextProvider>
        </ReportsContextProvider>
      </MembersContextProvider>
    </PredictionsInfoContext>
  );
};
